<template>
    <div id="app" :class="$globalStore.state.useNewGUI?'newdesign':''">
        <v-app>
            <user-info-view ref="userInfoDlg"></user-info-view>
            <about-info-view ref="infoDlg"></about-info-view>
            <confirm-view ref="confirmDlg"></confirm-view>
            <log-out-view ref="logoutDlg"></log-out-view>
            <add-notify-view ref="addNotifyDlg"></add-notify-view>
            <confirm-one-val-view ref="confirmOneValDlg"></confirm-one-val-view>
            <progress-view ref="progressDlg"></progress-view>
            
            <router-view></router-view> 
        </v-app>
    </div>
</template>

<script>
    
import{ conf } from '@/utils/confTruePLM';
import { auth } from '@/utils/auth';

import AboutInfo from '@/components/Dlg/AboutInfo.vue'
import LogOut from '@/components//Dlg/LogOut.vue'
import Confirm from '@/components/Dlg/Confirm.vue'
import AddNotify from '@/components/Dlg/AddNotify.vue';
import ConfirmOneVal from '@/components/Dlg/ConfirmOneVal.vue'
import Progress from '@/components/Dlg/Progress.vue'
import UserInfo from '@/components/Dlg/UserInfo.vue';
import settings from '@/utils/settings';

export default {
  name: 'App',
  data() {
      return {
        settings: settings
      };
    },
  methods:
  {
      procError( err )
      {
          let printErr = true;
          
          if( !err.message && err.response )
              err.message = err.response;
          
          if( err.message === 'Session expired!' )
              this.$modalDlg.sysDlgs.logoutDlg.open( 'no_session_msg', 'no_session_ttl', true );  
          else if( err.message === 'noConnInfo' || err.message === 'Connection expired' )
              this.$modalDlg.sysDlgs.logoutDlg.open( 'no_session_msg', 'no_session_ttl', true );
          else if( err.message === 'Wrong proj name' )
              this.$modalDlg.sysDlgs.confirmDlg.openError( 'error_ttl', 'error_proj_name_msg' );
          else if( err.message === 'Rstat Error: 50100' )
              this.$modalDlg.sysDlgs.confirmDlg.openError( 'error_ttl', 'error_50100_msg' );
          else if( err.message === 'baseline_create' )
              this.$modalDlg.sysDlgs.confirmDlg.openError( 'error_ttl', 'error_' + err.message + '_msg' );
          else if( err.message === 'Index: 0, Size: 0' )
          {
              
          }
          else
          {
              try{
                err.message = JSON.parse( err.message );
              }catch(e){/**noop */}
              if( err.message.errors )
              {
                  err.message.errors.forEach( er =>
                  {
                      console.log( er );
                  });
                  printErr = false;
              }
              if( err.message.message === 'linked docs' )
                  this.$modalDlg.sysDlgs.confirmDlg.openError( 'error_ttl', 'error_linked_docs_msg' );
              else
                  this.$modalDlg.sysDlgs.confirmDlg.open( 'error_ttl', 'error_from_server_msg', 
                        null, err.message.message || err.message, true, 'error', 'red' );
          }
          
          if( printErr )
              console.log( err.message, err );
      }
  },
  components: {
    'log-out-view': LogOut,
    'about-info-view': AboutInfo,
    'confirm-view': Confirm,
    'confirm-one-val-view': ConfirmOneVal,
    'add-notify-view': AddNotify,
    'progress-view': Progress,
    'user-info-view': UserInfo
  },
  beforeMount: function()
  {
      let serverInfo = this.settings.servers[ 0 ];
      auth.getInitInfo( serverInfo )
              .then( ( info ) =>
      {
//          console.log( info );
          this.$globalStore.setInitInfo( info );

          /*
          info.config = 'simple_nodes_and_documents';
          if (info.config && info.config !== 'full') {
            try{
              const r = await fetch(`/featuresets/${info.config}.json`); 
              const fs = await r.json();
              console.log("Try to load featureset:"+info.config, fs);
              FeaturesSet.init(fs);
            }catch(ex){
              console.error("The featureset '"+info.config+"' loading and init is failed", ex);
            }
          }*/

          if( info.auto_user && info.auto_pass )
             this.$eventBus.$emit( 'autoLogin', info ); 
      });
      this.$globalStore.checkPlatform();
  },
  mounted: function()
  {
      this.$modalDlg.sysDlgs[ 'progressDlg' ] = this.$refs.progressDlg;
      this.$modalDlg.sysDlgs[ 'confirmDlg' ] = this.$refs.confirmDlg;
      this.$modalDlg.sysDlgs[ 'confirmOneValDlg' ] = this.$refs.confirmOneValDlg;
      this.$modalDlg.sysDlgs[ 'userInfoDlg' ] = this.$refs.userInfoDlg;
      this.$modalDlg.sysDlgs[ 'logoutDlg' ] = this.$refs.logoutDlg;
      this.$modalDlg.sysDlgs[ 'infoDlg' ] = this.$refs.infoDlg;
      this.$modalDlg.sysDlgs[ 'addNotifyDlg' ] = this.$refs.addNotifyDlg;
      
      let self = this;
      this.$eventBus.$on( 'queryError', function( err )
      {
          self.procError( err );
      });
      
      this.$eventBus.$emit( 'appReady' );
  },
  beforeDestroy: function()
  {
      this.$eventBus.$off( 'queryError' );
  }
}
</script>

<style>
  .cut-text 
  { 
    text-overflow: ellipsis;
    overflow: hidden; 
    max-width: 130px; 
    /*height: 1.2em;*/ 
    white-space: nowrap;
  }
  .node_img
  {
      width: 2em;
      background: white;
  }
  
  @font-face {
    font-family: 'OwnersText';
    src: url('assets/fonts/OwnersText-Light.woff2') format('woff2');
    font-weight: 200;
  }

  @font-face {
    font-family: 'OwnersText';
    src: url('assets/fonts/OwnersText-Bold.woff2') format('woff2');
    font-weight: 800;
  }

  @font-face {
    font-family: 'OwnersText';
    src: url('assets/fonts/OwnersText-Medium.woff2') format('woff2');
    font-weight: 600;
  }

  @font-face {
    font-family: 'OwnersText';
    src: url('assets/fonts/OwnersText-Regular.woff2') format('woff2');
    font-weight: 400;
  }

#app {
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
  /*height: 95%;*/
  /*overflow-y: no-display !important;*/
  width: 100%;
  height: 100%;
  background-color: #EEEEEE;
  font-family: 'OwnersText', Roboto, sans-serif;
  font-weight: 400;
}
 html, body {
    /*height: 95%;*/
    /*overflow-y: no-display !important;*/
    font-family: 'OwnersText', Roboto, sans-serif;
    overflow: hidden !important;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-color: #EEEEEE;

    --brand-main-color: #05868C;
    --brand-light-color: #B5E2E5;
    --text-color: #777;
    --brand-danger-color: #fc0938;


  }

div[role=menu] .v-list-item{
    padding: 0 4px 0 8px;
    min-height: 40px;
}

div[role=menu] .v-list-group--no-action > .v-list-group__items .v-list-item{
    padding-left: 20px;
}

.ctx-menu .v-list-item{
  padding: 0 8px;
}

#app .v-card__title
{
    word-break: normal;
    overflow-y: hidden;
}

.v-navigation-drawer--fixed{
  z-index: 100 !important;
}

#app .v-list-group__header__prepend-icon
{
    margin-right: 0px;
}
#app .v-list-group__header__append-icon
{
    min-width: 10px;    
}

#app .v-list-item__title
{
    font-size: 14px;
    line-height: inherit;
}

#app .v-list-item__content
{
    font-size: 14px;
}

.v-menu__content {
    max-height: calc(100% - 24px);
}

.deleted_prop
{
    font-style: italic;
}

.mandatory_field {
  white-space: nowrap;
}

.mandatory_field:after {
  content:" *";
  color: red;
  white-space: nowrap;
}

.mandatory_value
{
   display: table-cell;
   border-bottom: 2px solid red;
   float: left;
   width: 100%;
   height: 90%;
}

.conTabMenu
{
  margin-left: -10px;
  margin-right: -10px;
  min-height: 30px !important;
}

.tabulator-selected
{
  background-color: var(--brand-main-color) !important;
  color: white;
}

.newdesign .v-slide-group__content {
    background-color: #dedede;
}

.v-data-table-header th
{
  white-space: nowrap;
}
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #fafafa !important;
}

.fillParent {
    display: flex; 
    flex-direction: column; 
    width: 100%; 
    height: 100%;
    flex: 1 1;
}

.tunedScrollBar::-webkit-scrollbar, .tunedScrollBar *::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.tunedScrollBar::-webkit-scrollbar-track, .tunedScrollBar *::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: transparent;
}

.tunedScrollBar::-webkit-scrollbar-track:hover, .tunedScrollBar *::-webkit-scrollbar-track:hover {
  background-color: #EDEDED;
}

.tunedScrollBar::-webkit-scrollbar-track:active, .tunedScrollBar *::-webkit-scrollbar-track:hover {
  background-color: #DEDEDE;
}

.tunedScrollBar::-webkit-scrollbar-thumb, .tunedScrollBar *::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #BABABA;
  border: 2px solid #FFFFFF;
}

.tunedScrollBar::-webkit-scrollbar-thumb:hover, .tunedScrollBar *::-webkit-scrollbar-thumb:hover {
  background-color: #909090;
}

.tunedScrollBar::-webkit-scrollbar-thumb:active, .tunedScrollBar *::-webkit-scrollbar-thumb:active {
  background-color: #7DBDE8;
}

.questionIcon{
    color: #CCC !important;
    font-size: 16px !important;
    font-weight:400 !important;
    padding: 3px !important;
}
</style>
